module.exports = __webpack_public_path__ + "static/img/downloadQRcode.e083aa8e.png";